import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@shared/interfaces/address.interface';
import { TranslateService } from '@ngx-translate/core';
import { BaseHttpService } from '@shared/services/base-http.service';
import { AppInjector } from '@shared/services/app-injector.service';

@Pipe({
    name: 'formattedAddress'
})
export class FormattedAddressPipe implements PipeTransform
{
    translate: TranslateService;

    constructor (public baseHttp: BaseHttpService) {
        const injector = AppInjector.getInjector();
        this.translate = injector.get(TranslateService);
    }

    transform(value: Address): string {
        const data = [
          value.name,
          value.street,
          value.city,
          value.commune,
          value.voivodeship,
          value.county
        ];

        if (value.country) {
            data.push(this.translate.instant('COUNTRIES.' + value.country));
        }

        return data.filter(x => x).join(', ');
    }
}
